import { render, staticRenderFns } from "./Vaccine.vue?vue&type=template&id=c27ddf0c&scoped=true&"
import script from "./Vaccine.vue?vue&type=script&lang=js&"
export * from "./Vaccine.vue?vue&type=script&lang=js&"
import style0 from "./Vaccine.vue?vue&type=style&index=0&id=c27ddf0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27ddf0c",
  null
  
)

export default component.exports